module.exports = __webpack_public_path__ + "ydph.png?cb6e9d9bd44c1f919f44ba3108786033";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ydph.png
// module id = 672
// module chunks = 0